export const PageDataState = {
    Searchs: {
        course_eb_01_id: {
            type: 'text',
            id: 'course_eb_01_id',
            label: '',
            value: '',
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'ผลกระทบ/ประโยชน์',
            value: '',
            placeholder: 'ผลกระทบและประโยชน์ที่คาดว่าจะได้รับ (Impact)',
        }
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        course_eb_01_id: {
            type: 'select',
            id: 'course_eb_01_id',
            label: 'หลักสูตร EB-01',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'textarea',
            rows: 3,
            id: 'name',
            label: 'ผลกระทบและประโยชน์ที่คาดว่าจะได้รับ (Impact)',
            value: '',
            validator: {
                type: 'text',
                required: true,
                // minLength: 5,
                // maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}